import React from 'react';
import './DragHandle.css';

interface DragHandleProps {
    isDragging?: boolean;
}

const DragHandle: React.FC<DragHandleProps> = ({ isDragging }) => {
    return (
        <div className={`drag-handle ${isDragging ? 'dragging' : ''}`} title="Arrastar para reordenar">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="7" cy="5" r="1.5" />
                <circle cx="13" cy="5" r="1.5" />
                <circle cx="7" cy="10" r="1.5" />
                <circle cx="13" cy="10" r="1.5" />
                <circle cx="7" cy="15" r="1.5" />
                <circle cx="13" cy="15" r="1.5" />
            </svg>
        </div>
    );
};

export default DragHandle;